import {useManufacturerContext} from '../../context/ManufacturerContext';
import {ProductSwiper} from '../../../common/ui/ProductSwiper';
import React from 'react';
import {mapRemoteData} from '../../../common/domain/RemoteData.model';
import {fetchAllBis} from "../../../features/catalog/infrastructure/CatalogService";
import {useComercialContext} from "../../../comercial/ComercialContext";

export const ManufacturerProducts = () => {
  const { details } = useManufacturerContext();
  const { actingAsCliente } = useComercialContext();

  if (details?.codigo) {
    const actingAsNumCliente = actingAsCliente?.numCliente ?? null;
    const fetchFn = () =>
      fetchAllBis({ manufacturerIds: [details.id] }, { amount: 50, page: 0 }, actingAsNumCliente)
      .then(rd => mapRemoteData(rd, ({ content }) => content));
    return (
      <ProductSwiper title="PRODUCTOS DEL FABRICANTE" fetchFn={fetchFn} />
    );
  }
};